export { SortableDataTableLegacy } from './SortableDataTableLegacy';
export { useSortableDataTableLegacyState } from './useSortableDataTableLegacy';
